import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import {
    ContinuousScanningToastMessage,
    ContinuousScanningToastMessageService,
} from '@data-terminal/ui-smart/services/continuous-scanning-toast-message.service';

@UntilDestroy()
@Component({
    selector: 'data-terminal-toast-notification',
    imports: [CommonModule, TranslateModule, MatButtonModule],
    templateUrl: './toast-notification.component.html',
    styleUrl: './toast-notification.component.scss',
})
export class ToastNotificationComponent {
    readonly #continuousScanningNotificationService = inject(ContinuousScanningToastMessageService);

    public readonly messages$: Observable<ContinuousScanningToastMessage[]> =
        this.#continuousScanningNotificationService.toastMessages$.pipe(untilDestroyed(this));

    public confirmScanning(toastMessage: ContinuousScanningToastMessage): void {
        this.#continuousScanningNotificationService.confirmScanning(toastMessage);
    }

    public discardScanning(toastMessageId: string): void {
        this.#continuousScanningNotificationService.discardScanning(toastMessageId);
    }
}
